import { useState, useEffect } from 'react'

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000'

export const useFetch = (path, defaultValue = null) => {
  const [data, setData] = useState(defaultValue)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    const fetchData = async () => {
      setLoading(true)
      setError(null)
      try {
        const res = await fetch(`${API_BASE}${path}`)
        if (!res.ok) throw new Error(`API error ${res.status}`)
        const json = await res.json()
        if (!cancelled) setData(json)
      } catch (err) {
        if (!cancelled) setError(err.message)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchData()

    return () => {
      cancelled = true
    }
  }, [path])

  return { data, loading, error }
}
